module.exports = __webpack_public_path__ + "static/media/cms-about-icon.c4da901f.svg";